import React, { ChangeEvent, FormEvent } from 'react';
import {
	Typography,
	makeStyles,
	TextField,
	Grid,
	Button,
	InputLabel,
	Theme,
} from '@material-ui/core';
import { useAppState } from '../../../state';

const useStyles = makeStyles((theme: Theme) => ({
	gutterBottom: {
		marginBottom: 6,
	},
	hint: {
		color: theme.palette.text.secondary,
	},
	inputContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		margin: '20px 0 28px',
		'& div:not(:last-child)': {
			marginRight: '1em',
		},
		[theme.breakpoints.down('sm')]: {
			margin: '16px 0 24px',
		},
	},
	textFieldContainer: {
		width: '100%',
	},
	label: {
		position: 'static',
		transform: 'none',
		marginBottom: 8,
	},
	continueButton: {
		minHeight: 48,
		minWidth: 160,
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			minHeight: 52,
		},
	},
}));

interface RoomNameScreenProps {
	name: string;
	roomName: string;
	setName: (name: string) => void;
	setRoomName: (roomName: string) => void;
	handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export default function RoomNameScreen({
	name,
	roomName,
	setName,
	handleSubmit,
}: RoomNameScreenProps) {
	const classes = useStyles();
	const { user } = useAppState();

	const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
		setName(event.target.value);
	};

	const hasUsername =
		!window.location.search.includes('customIdentity=true') &&
		user?.displayName;

	return (
		<>
			<Typography
				variant="h5"
				component="h1"
				className={classes.gutterBottom}
			>
				Join video chat
			</Typography>
			<Typography variant="body1" id="name-hint" className={classes.hint}>
				{hasUsername
					? 'Enter your name'
					: "Enter your name so we know who we're chatting with."}
			</Typography>
			<form onSubmit={handleSubmit}>
				<div className={classes.inputContainer}>
					{!hasUsername && (
						<div className={classes.textFieldContainer}>
							<InputLabel
								shrink
								disableAnimation
								htmlFor="input-user-name"
								className={classes.label}
							>
								Your Name
							</InputLabel>
							<TextField
								id="input-user-name"
								variant="outlined"
								fullWidth
								value={name}
								onChange={handleNameChange}
								autoComplete="name"
								inputProps={{ 'aria-describedby': 'name-hint' }}
							/>
						</div>
					)}
				</div>
				<Grid container justifyContent="flex-end">
					<Button
						variant="contained"
						type="submit"
						color="primary"
						disabled={!name || !roomName}
						className={classes.continueButton}
					>
						Continue
					</Button>
				</Grid>
			</form>
		</>
	);
}
